import React from 'react';
import '../css/loginModal.css';

export default function TermsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <i className="fas fa-file-contract"></i>
            Terms and Conditions
          </h2>
          <button className="modal-close" onClick={handleClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <div style={{ maxHeight: '600px', overflowY: 'auto', paddingRight: '10px' }}>
            <header style={{ marginBottom: '20px' }}>
              <h2 style={{ color: '#1a2980', marginBottom: '16px' }}>Hiverooms Marketplace Terms &amp; Conditions</h2>
              <p>Welcome to <strong>Hiverooms!</strong> These Terms and Conditions ("Terms") govern your access to and use of the Hiverooms online marketplace, including our websites, mobile applications, and all other services (collectively, the "Platform"). Hiverooms is a marketplace where guests can book a wide range of services, including hotels, resorts, vacation houses, tours, team-building activities, and events.</p>
              <p><strong>By using our Platform, you agree to comply with and be legally bound by these Terms. Please read them carefully.</strong></p>
            </header>

            <section>
              <h3>1. General Provisions</h3>
              <p><strong>1.1. Scope of Services:</strong> Hiverooms is a marketplace that connects users ("Guests") with other companies ("Partners") that offer a variety of accommodations, activities, and events. While we help you find and book these services, the Partners are the ones who actually provide them.</p>
            </section>

            <section>
              <h3>2. Booking Accommodations</h3>
              <p><strong>2.1. Booking Process:</strong> When you book an accommodation, you are entering into a direct contract with the Partner. Hiverooms' role is limited to facilitating the booking and payment process.</p>
              <p><strong>2.2. Cancellation Policy:</strong> The cancellation and refund policy for each accommodation booking is determined by the respective Partner. You must review and agree to the Partner's specific policy before completing your reservation.</p>
            </section>

            <section>
              <h3>3. Booking Accommodations, Activities &amp; Tours</h3>
              <p><strong>3.1. Non-Refundable Policy:</strong> Bookings for HiveRooms Accommodation, activities, tours, team-building sessions, and other pursuits are generally non-refundable.</p>
              <p><strong>3.2. Rescheduling Policy:</strong> If a Guest is unable to attend a booked activity, the primary option is to reschedule. Any schedule change must be agreed upon by the Guest, Hiverooms, and the Partner to be considered valid. Hiverooms will work with all parties to find a suitable new time slot, but this is subject to the Partner's availability.</p>
              
              <h4 style={{ marginTop: '16px', marginBottom: '8px', color: '#2c3e50' }}>3.3. Sea Activities:</h4>
              <ul>
                <li>For all sea activities, the Partner is required to provide all necessary safety equipment to ensure the well-being of the Guest.</li>
                <li>Guests agree that pictures and videos may be taken during the activity. By participating, the Guest grants Hiverooms and the Partner the right to use this media for promotional activities on the Platform and social media, without further compensation or notice.</li>
              </ul>
            </section>

            <section>
              <h3>4. Events</h3>
              <p><strong>4.1. General Events:</strong> The terms for events are set by the event organizer or Partner. You are responsible for reviewing their specific policies before purchasing tickets.</p>
              <p><strong>4.2. Exclusive Hiverooms Events:</strong> Some events are curated and hosted exclusively by Hiverooms. These events may have unique rules and policies which will be clearly detailed on the event page. Bookings for these events are also non-refundable, but rescheduling may be considered under extenuating circumstances at Hiverooms' sole discretion.</p>
            </section>

            <section>
              <h3>5. Payments &amp; Fees</h3>
              <p><strong>5.1. Payment Processing:</strong> Hiverooms uses third-party payment processors to handle all transactions. By making a payment, you agree to the terms and conditions of these processors.</p>
              <p><strong>5.2. Service Fees:</strong> Hiverooms may charge a service fee for using the Platform, which will be clearly displayed before you confirm your booking.</p>
            </section>

            <section>
              <h3>6. Guest Responsibilities</h3>
              <p>You are responsible for providing accurate and complete information during booking. You must also comply with all rules and regulations set by the Partners during your stay or activity.</p>
            </section>

            <section>
              <h3>7. Limitation of Liability</h3>
              <p>Hiverooms is not liable for any injury, damage, loss, or expense incurred as a result of using the services provided by Partners. We do not endorse any Partner and are not responsible for the quality, safety, or legality of their services.</p>
            </section>

            <section>
              <h3>8. Governing Law &amp; Dispute Resolution</h3>
              <p>These Terms are governed by and construed in accordance with the laws of the <strong>Philippines</strong>. Any disputes will be resolved through good faith negotiation.</p>
            </section>

            <footer style={{ marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e9ecef', fontSize: '0.875rem', color: '#6c757d', textAlign: 'center' }}>
              <p><strong>Hiverooms Marketplace</strong> - Connecting Guests with Amazing Experiences</p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
}